import { instance } from "../../config/intercepter";

// GET Requests

export const getDeliveryGetStatusFn = async ({plateno}) => {
  const response = await instance.get(`api/vehicledelivery/status?plateno=${plateno}`);
  return response.data;
};

export const getDeliveryInitializeFieldsFn = async () => {
  const response = await instance.get(`api/vehicledelivery/create`);
  return response.data;
};

export const getVehicleDeliveryCurrentStepFn = async (vehicleFlowId) => {
  const response = await instance.get(
    `api/vehicledelivery/${vehicleFlowId}/create`
  );
  return response.data;
};

export const getVehicleDeliveryShowSummaryFn = async (vehicleFlowId) => {
  const response = await instance.get(`api/vehicledelivery/${vehicleFlowId}`);
  return response.data;
};

// POST Requests
export const getVehicleDeliveryCancelFn = async ({vehicleFlowId,payload}) => {
  // const mockPayload = {};
  const response = await instance.post(`api/vehicledelivery/${vehicleFlowId}/cancel`, payload);
  return response.data;
};

export const getVehicleDeliveryUndoStepFn = async ({vehicleFlowId,payload}) => {
    // const mockPayload = {};
  const response = await instance.post(`api/vehicledelivery/${vehicleFlowId}/undo`, payload);
  return response.data;
};

export const vehicleDeliveryEntryBookingStepFn = async ({payload}) => {
  // const mockPayload = {
  //   plateno: "XZZ4295",
  // };
  const response = await instance.post(`api/vehicledelivery`, payload);
  return response.data;
};

export const vehicleDeliveryOptionSelectionFn = async ({
  vehicleFlowId,
  payload,
}) => {
  // const mockPayload = {
  //   // optionSelection: "GarageDelivery",
  //   // optionSelection: "HomeDelivery",
  // };
  const response = await instance.post(
    `api/vehicledelivery/${vehicleFlowId}/optionSelection`,
    payload
  );
  return response.data;
};

export const vehicleDeliveryAddressFn = async ({ vehicleFlowId, payload }) => {
  // const mockPayload = {
  //   // deliveryAddress: "Σκρα 22, Καλλιθέα 17673 Ελλάδα",
  // };
  const response = await instance.post(
    `api/vehicledelivery/${vehicleFlowId}/deliveryAddress`,
    payload
  );
  return response.data;
};

export const vehicleDeliveryBookingFn = async ({ vehicleFlowId, payload }) => {
  // const mockPayload = {
  //   bookingSelect: "ΜΕΤΑΜΟΡΦΩΣΗ",
  //   bookingCalendar: "2025-10-09T07:00:00Z",
  // };
  const response = await instance.post(
    `api/vehicledelivery/${vehicleFlowId}/booking`,
    payload
  );
  return response.data;
};

export const vehicleDeliveryAdditionalCommentsFn = async ({
  vehicleFlowId,
  payload,
}) => {
  // const mockPayload = {
  //   additionalComments: "comment",
  // };
  const response = await instance.post(
    `api/vehicledelivery/${vehicleFlowId}/additionalComments`,
    payload
  );
  return response.data;
};

// export const vehicleDeliveryWorkSelectionFn = async ({
//   vehicleFlowId,
//   payload,
// }) => {
//   // const mockPayload = {
//   //   // workSelection: ["standarizedVehicle", "tyreChange", "bodyWork"],
//   //   // workSelection: ["standarizedVehicle", "tyreChange"],
//   //   // workSelection: ["standarizedVehicle", "bodyWork"],
//   //   // workSelection: ["tyreChange", "bodyWork"],
//   //   // workSelection: ["standarizedVehicle"],
//   //   // workSelection: ["bodyWork"],
//   //   // workSelection: ["tyreChange"],
//   //   // workSelection: ["standarizedVehicle", "tyreChange"],
//   // };
//   const response = await instance.post(
//     `api/vehiclebooking/${vehicleFlowId}/workSelection`,
//     payload
//   );
//   return response.data;
// };

// export const vehicleDeliveryLocationFn = async ({ vehicleFlowId, payload }) => {
//   // const mockPayload = {
//   //   // location: "Καλλιθέα",
//   //   // location: "Θεσσαλονίκη",
//   //   // location: "Ηράκλειο, Kρήτη",
//   //   // location: "Πάτρα",
//   // };
//   const response = await instance.post(
//     `api/vehiclebooking/${vehicleFlowId}/location`,
//     payload
//   );
//   return response.data;
// };


// export const vehicleDeliveryTyreChangeFn = async ({
//   vehicleFlowId,
//   payload,
// }) => {
//   // const mockPayload = {
//   //   frontTyreWidth: 235,
//   //   frontTyreHeight: 55,
//   //   frontTyreDiameter: 16,
//   //   tyreRunFlat: true,
//   //   rearSameAsFront: false,
//   //   rearTyreWidth: 205,
//   //   rearTyreHeight: 65,
//   //   rearTyreDiameter: 17,
//   // };
//   const response = await instance.post(
//     `api/vehiclebooking/${vehicleFlowId}/tyreChange`,
//     payload
//   );
//   return response.data;
// };

// export const vehicleDeliveryBodyWorkFn = async ({ vehicleFlowId, payload }) => {
//   // const mockPayload = {
//   //   bodyWork: 'Fix the front bumper',
//   //   //form data input
//   //   bodyWorkPhotos_1: 'file 1',
//   //   bodyWorkPhotos_2: 'File 2',
//   //   bodyWorkPhotos_3: 'file 3',
//   //   accidentReport:'file.pdf'
//   // };
//   const response = await instance.post(
//     `api/vehiclebooking/${vehicleFlowId}/bodyWork`,
//     payload,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );
//   return response.data;
// };

// export const vehicleDeliveryCRMFormFn = async ({ vehicleFlowId, payload }) => {
//   // const mockPayload = {
//   //   preferredTimeslots: ["2025-10-13T11:00:00Z", "2025-10-14T08:00:00Z"],
//   //   preferredGarage: "f277cb77-b671-ef11-a670-6045bd905f5a",
//   // };
//   const response = await instance.post(
//     `api/vehiclebooking/${vehicleFlowId}/formForCRM`,
//     payload
//   );
//   return response.data;
// };
